import React, { useState } from 'react';

function StepTen({ formData, onNext }) {
    const [nationalInsurance, setNationalInsurance] = useState(formData.nationalInsurance || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!nationalInsurance.trim()) {
            setError('Please enter your National Insurance number.');
            return;
        }

        setError('');
        onNext({ nationalInsurance });
    };

    const isFormValid = nationalInsurance.trim();

    return (
        <div className="step-form">
            <h6 className="mb-4">National Insurance Number</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
                <label className="form-label">
                    What is your National Insurance number? <span className="text-danger">*</span>
                </label>
                <textarea
                    className="form-control"
                    rows="3"
                    value={nationalInsurance}
                    onChange={e => setNationalInsurance(e.target.value)}
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepTen;
